import {
  DomainSessionId,
  JourneyAlias,
  JourneyId,
  ProductType,
  SessionId,
  UserId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

import { PlateName } from './plate-name';

export const Visit = z.object({
  domainSessionId: DomainSessionId,
  plateId: PlateName,
  product: ProductType,
  sessionId: SessionId,
  userId: UserId,
  journeyId: JourneyId,
  journeyAlias: JourneyAlias,
});

// eslint-disable-next-line no-redeclare
export type Visit = z.infer<typeof Visit>;
